import { PollResults } from '@core/poll';

import { PollWithVotes } from '@core/types';
import { PollQuestion } from '../../atoms';

interface Props {
    poll: PollWithVotes;
    index: number;
}

export const PollCard = ({ poll, index }: Props) => (
    <div className="flex mb-4">
        <div className="size-10 rounded-l-lg rounded-br-lg bg-white text-sm font-medium inline-flex items-center justify-center">{index + 1}.</div>
        <div className="bg-white rounded-b-lg rounded-r-lg flex-1 p-4">
            <PollQuestion classNames="bg-white border-b border-primary p-2 text-lg" question={poll.question} />
            <PollResults poll={poll} />
        </div>
    </div>
);
